import { createAction, createSlice } from "@reduxjs/toolkit";
import { Document } from "../../@types/document";
import { Location } from "../../@types/location";
import { Message } from "../../@types/message";
import { UserRole } from "../../@types/userRole";
import { UserFile } from "../../@types/userFiles";
import { updateFormAnswer } from "./actions/updateFormAnswer";
import createArchive from "./actions/createArchive";
import { createUserRole } from "./actions/createUserRole";
import { findDocuments } from "./actions/findDocuments";
import { findFormsSubmitted } from "./actions/findFormsSubmitted";
import { findLocation } from "./actions/findLocation";
import { findMessages } from "./actions/findMessages";
import { findMultipleFormsSubmitted } from "./actions/findMultipleFormsSubmitted";
import { findUserRoles } from "./actions/findUserRoles";
import { FormAnswer } from "../../@types/formAnswer";
import { findLocationDocuments } from "./actions/findLocationDocuments";
interface LocationShowState {
  location: Location;
  locationFetchStatus: string;
  userRoles?: UserRole[];
  messages?: Message[];
  segmentSelected: string;
  userRolesSearchText: string;
  documents: Document[];
  documentsFetchStatus: string;
  documentSearchText: string;
  formsSubmitted: any;
  showModalFormAnswerSelected: boolean;
  formAnswerSelected: FormAnswer;
  locationDocumentsList?: UserFile[];
  locationDocumentsFetchStatus?: string;
  maxListIndex: number;
}

const initialState = {
  location: {},
  locationFetchStatus: "",
  userRoles: [],
  messages: [],
  segmentSelected: "",
  userRolesSearchText: "",
  documents: [],
  documentsFetchStatus: "",
  documentSearchText: "",
  formsSubmitted: [],
  showModalFormAnswerSelected: false,
  formAnswerSelected: {},
  locationDocumentsFetchStatus: "",
  maxListIndex: 0,
} as LocationShowState;

export const setSegmentSelected = createAction<string>("SET_SEGMENT_SELECTED");
export const setUserRolesSearchText = createAction<string>("setUserRolesSearchText");
export const setDocumentSearchText = createAction<string>("setDocumentSearchText");
export const setFormAnswerSelected = createAction<any>("setFormAnswerSelected");
export const setShowModalFormAnswerSelected = createAction<any>("setShowModalFormAnswerSelected");

const locationShowSlice = createSlice({
  name: "locationShow",
  initialState,
  reducers: {
    setMaxListIndex: (state, { payload }) => {
      state.maxListIndex = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setUserRolesSearchText, (state, { payload }) => {
        state.userRolesSearchText = payload;
      })
      .addCase(setSegmentSelected, (state, { payload }) => {
        state.segmentSelected = payload;
      })
      // findLocation
      .addCase(findLocation.pending, (state, { payload }) => {
        // state.segmentSelected = "history";
        state.location = {};
        state.locationFetchStatus = "pending";
      })
      .addCase(findLocation.fulfilled, (state, { payload }) => {
        state.location = payload;
        state.locationFetchStatus = "fulfilled";
      })
      // findUserRoles
      .addCase(findUserRoles.pending, (state, { payload }) => {
        state.userRoles = [];
      })
      .addCase(findUserRoles.fulfilled, (state, { payload }) => {
        state.userRoles = payload;
      })
      // findMessages
      .addCase(findMessages.pending, (state) => {
        state.messages = [];
      })
      .addCase(findMessages.fulfilled, (state, { payload }) => {
        state.messages = payload;
      })
      .addCase(createUserRole.fulfilled, (state, { payload }) => {
        state.userRoles?.push(payload);
      })
      .addCase(createArchive.fulfilled, (state, { payload }) => {
        state.location.picture = payload;
      })
      //
      .addCase(setDocumentSearchText, (state, { payload }) => {
        state.documentSearchText = payload;
      })
      // findDocuments
      .addCase(findDocuments.pending, (state) => {
        state.documents = [];
        state.documentsFetchStatus = "pending";
      })
      .addCase(findDocuments.fulfilled, (state, { payload }) => {
        const [documents] = payload;
        state.documents.push(...documents);
        state.documentsFetchStatus = "fulfilled";
      })
      // Buscar formularios
      .addCase(findFormsSubmitted.pending, (state) => {
        state.formsSubmitted = {};
      })
      .addCase(findFormsSubmitted.fulfilled, (state, { payload }) => {
        state.formsSubmitted = payload;
      })
      .addCase(updateFormAnswer.fulfilled, (state, { payload }) => {
        state.formsSubmitted = {
          ...state.formsSubmitted,
          ...payload,
          answers: state.formsSubmitted.answers.map((answerItem: any) =>
            answerItem.id === payload.id ? payload : answerItem
          ),
        };
        state.showModalFormAnswerSelected = false;
      })
      .addCase(setFormAnswerSelected, (state, { payload }) => {
        state.formAnswerSelected = payload;
        state.showModalFormAnswerSelected = true;
      })
      .addCase(setShowModalFormAnswerSelected, (state, { payload }) => {
        state.showModalFormAnswerSelected = payload;
      })
      //Find location Documents
      .addCase(findLocationDocuments.pending, (state) => {
        state.locationDocumentsFetchStatus = "pending";
        state.locationDocumentsList = [];
      })
      .addCase(findLocationDocuments.fulfilled, (state, { payload }) => {
        state.locationDocumentsList = payload;
        state.locationDocumentsFetchStatus = "fulfilled";
      });
  },
});

export const { setMaxListIndex } = locationShowSlice.actions;

export default locationShowSlice.reducer;
